export function arraysIntersect<T>(arr1: T[], arr2: T[]): boolean {
  for (const element of arr1) {
    if (arr2.includes(element)) {
      return true;
    }
  }
  return false;
}

export function arrayIntersection<T>(arr1: T[], arr2: T[]): T[] {
  return arr1.filter((element) => arr2.includes(element));
}

export function arraysHaveSameElements<T extends string | number>(
  arr1: T[],
  arr2: T[]
): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  arr1.sort();
  arr2.sort();

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export function removeDuplicates<T>(arr: T[]): T[] {
  return Array.from(new Set(arr));
}

export function getNumItemsBetween(index1: number, index2: number): number {
  return Math.abs(index1 - index2) + 1;
}

/**
 * Filter functions
 */
export function out<T>(element: T): (el: T, index: number) => boolean {
  return (el) => el !== element;
}
